import { loansConstants } from "../_constants";

export const loansListRequest = (payload) => {
  return {
    type: loansConstants.LOANS_LIST_REQUEST,
    payload,
  };
};

export const loansListComplete = (payload) => {
  return {
    type: loansConstants.LOANS_LIST_COMPLETE,
    payload,
  };
};

export const loansListsError = (payload) => {
  return {
    type: loansConstants.LOANS_LIST_ERROR,
    payload,
  };
};

export const loansActivityListRequest = (payload) => {
  return {
    type: loansConstants.LOANS_ACTIVITY_LIST_REQUEST,
    payload,
  };
};

export const loansActivityListComplete = (payload) => {
  return {
    type: loansConstants.LOANS_ACTIVITY_LIST_COMPLETE,
    payload,
  };
};

export const loansActivityListsError = (payload) => {
  return {
    type: loansConstants.LOANS_ACTIVITY_LIST_ERROR,
    payload,
  };
};
